// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y7DA","delete":"styles_delete__10ory","update":"styles_update__2hO6Z","add":"styles_add__TpqBn"};